import { useQuery } from '@apollo/react-hooks';

import AFFILIATE_URL_QUERY from '../graphql/affiliateUrl.graphql';

type GraphqlData = {
  course: {
    affiliateUrl: string;
  };
};

type GraphqlVariables = {
  id: string;
};

const useAffiliateUrl = (courseId: string) => {
  const { loading, data, error } = useQuery<GraphqlData, GraphqlVariables>(
    AFFILIATE_URL_QUERY,
    {
      variables: {
        id: courseId,
      },
    },
  );

  return {
    loading,
    error,
    affiliateUrl: data?.course?.affiliateUrl,
  };
};

export default useAffiliateUrl;
